import getParticipantTemplate from "./ParticipantTemplate";
var $ = window.$ || {};

class ParticiantView{

	constructor(model)
	{
		this._model = model;
		this._parent = $("#hostParticipantStreamsList");
		this._id = model.id;
		this._name = model.firstName;
		this._order = model.order;
	}

	render(){
		var str = getParticipantTemplate({id:this._id, name:this._name, order:this._order});
		console.log('************************************');
		console.log(this._parent);
		this._parent.append(str);
		this._addEvents();
		if(this._model.videoMuted === true || this._model.isVisible === false){
			this._el.addClass("d-none");
		}
	}

	_addEvents(){
		this._el = $("#agora_remote"+this._id);
	}

	resetMarquee() {
		this._el = $("#agora_remote"+this._id);
      	// this._el.find('#mq-'+this._id).remove();
      	// this._el.find('#client-details-'+this._id).append('<marquee behavior="slide" id="mq-'+this._id+'"><span class="text_name px-1"><span class="font-weight-bold mb-0">'+this._name+'</span></span></marquee>');
	}

	show(){
		this._el.removeClass("d-none");
	}

	swapOrder(swapWith){
		this._el = $("#agora_remote"+this._id);
		let swapToOrder 	= parseInt($('#agora_remote'+swapWith).css("order"));
	  	let swapFromOrder 	= parseInt(this._el.css("order"));

	  	this._el.css('order', swapToOrder);
	  	$('#agora_remote'+swapWith).css('order', swapFromOrder);

	  	if ($('#'+swapWith).hasClass('remote_video_selected')) {
	      	$('#'+this._id).addClass('remote_video_selected');
	      	$('#'+swapWith).removeClass('remote_video_selected');
	  	}
	}
}

export default ParticiantView;